import { Component, Input, OnInit } from '@angular/core';
import { AtividadeParcelaService } from 'src/app/core/services/atividade-parcela.service';

@Component({
  selector: 'sgc-atividade-parcela-list',
  templateUrl: './atividade-parcela-list.component.html'
})
export class AtividadeParcelaListComponent implements OnInit {
  @Input() idAtividade!: number;
  parcelas: any[] = [];

  constructor(private atividadeParcelaService: AtividadeParcelaService) {}

  ngOnInit(): void {
    if (this.idAtividade) {
      this.atividadeParcelaService.listarParcelas(this.idAtividade).subscribe({
        next: (res) => this.parcelas = res,
        error: (err) => console.error('Erro ao buscar parcelas:', err)
      });
    }
  }
}
